import { CssBaseline, MuiThemeProvider } from "@material-ui/core";
import * as React from "react";
import { HomePage } from "./Components/Pages/HomePage";
import { Redirect, Route, Switch, useHistory, useParams, withRouter } from "react-router";
import { createApplicationTheme, createApplicationThemeDark } from "./Styles/ApplicationTheme";
import { GlobalSnackbar } from "./Components/UI/GlobalSnackbar";
import { PageWrapper } from "./Components/UI/PageWrapper";
import { useSelector } from "react-redux";
import { ReduxState, ThemeTypes } from "./Definitions/Definitions";
import { NotFoundPage } from "./Components/Pages/NotFoundPage";
import { AboutPage } from "./Components/Pages/AboutPage";
import { GamePage } from "./Components/Pages/GamePage";
import { JoinPage } from "./Components/Pages/JoinPage";
import { GameContextProvider } from "./Components/GameContext/GameContext";
import { FeedbackPage } from "./Components/Pages/FeedbackPage";

export const Routes = () => {
    const history = useHistory();
    const theme = useSelector((state: ReduxState) => state.theme);

    const authenticated = useSelector((state: ReduxState) => state.authenticated); 

    const getTheme = () => {
        return createApplicationThemeDark();
        //switch (theme) {
        //    default:
        //        return createApplicationTheme();
        //    case ThemeTypes.Dark:
        //        return createApplicationThemeDark();
        //    case ThemeTypes.Light:
        //        return createApplicationTheme();
        //}
    }

    // scroll to top upon navigation
    React.useEffect(() => {
        const unlisten = history.listen(() => {
            window.scrollTo(0, 0);
        })
        return () => {
            unlisten();
        };
    }, []);

    return (
        <MuiThemeProvider theme={getTheme()}>
            <CssBaseline />
            <GlobalSnackbar />
            <PageWrapper>
                <div style={{ margin: 10 }}>
                    {authenticated ?
                        <Switch>
                            <Route exact path={['/', '/home']} component={HomePage} />
                            <Route exact path={'/about'} component={AboutPage} />
                            <Route exact path={'/feedback'} component={FeedbackPage} />
                            <Route exact path={'/play/:roomIdString/:name'} render={() => <GameContextProvider><GamePage /></GameContextProvider>} />
                            <Route exact path={'/join/:roomIdString'} component={JoinPage} />

                            <Route exact path={'/account/signout'} component={() => <></>} />
                            <Route exact path={'/account/authenticate'} component={() => <></>} />

                            <Route path={'/'} component={NotFoundPage} />
                        </Switch>
                        :
                        <Switch>
                            <Route exact path={['/', '/home']} component={HomePage} />
                            <Route exact path={'/about'} component={AboutPage} />
                            <Route exact path={'/feedback'} component={FeedbackPage} />
                            <Route exact path={'/play/:roomIdString/:name'} render={() => <GameContextProvider><GamePage /></GameContextProvider>} />
                            <Route exact path={'/join/:roomIdString'} component={JoinPage} />

                            <Route exact path={'/account/signout'} component={() => <></>} />
                            <Route exact path={'/account/authenticate'} component={() => <></>} />

                            <Route path={'/'} component={() => <Redirect to={`/`} />} />
                        </Switch>
                    }
                </div>
            </PageWrapper>
        </MuiThemeProvider>
    );
};